import React from 'react'
import {ITableProps} from "@ui/tableCustom/types/table";
import BaseTableFeatures from './BaseTableFeatures'
import TableFeaturesWithModalFullScreen from "@ui/tableCustom/tableFeatures/TableFeaturesWithModalFullScreen";

function TableFeatures<T>({
                              isLoading,
                              isError,
                              hasExportDataFromAllPage,
                              mapperRowCb,
                              data,
                              allData,
                              fullColumns,
                              headColumns,
                              params,
                              headSideBar,
                              secondarySidebar,
                              hasExport = true,
                              exportParams,
                              mapperColumnCb,
                              baseExportStyles,
                              generateExportExcelRowStylesCb,
                              generateExportExcelHeadColumnStylesCb,
                              headerExportContents,
                              initialStickyHeader,
                              changeExportSidebarSettings,
                              hasPdfExport = true,
                              sx,
                              lastTableRow,
                              menuSettingsTable,
                              hasModalFullScreen = true,
                              totalPage,
                              paginationProps,
                          }: ITableProps<T>) {

    if (!hasModalFullScreen) {
        return (
            <BaseTableFeatures
                <T>
                isLoading={isLoading}
                isError={isError}
                hasExportDataFromAllPage={hasExportDataFromAllPage}
                mapperRowCb={mapperRowCb}
                data={data}
                allData={allData}
                fullColumns={fullColumns}
                headColumns={headColumns}
                params={params}
                headSideBar={headSideBar}
                secondarySidebar={secondarySidebar}
                hasExport={hasExport}
                exportParams={exportParams}
                mapperColumnCb={mapperColumnCb}
                baseExportStyles={baseExportStyles}
                generateExportExcelRowStylesCb={generateExportExcelRowStylesCb}
                generateExportExcelHeadColumnStylesCb={generateExportExcelHeadColumnStylesCb}
                headerExportContents={headerExportContents}
                initialStickyHeader={initialStickyHeader}
                changeExportSidebarSettings={changeExportSidebarSettings}
                paginationProps={paginationProps}
                hasPdfExport={hasPdfExport}
                sx={sx}
                lastTableRow={lastTableRow}
                menuSettingsTable={menuSettingsTable}
                hasModalFullScreen={hasModalFullScreen}
                totalPage={totalPage}
            />
        )
    }

    return (
        <TableFeaturesWithModalFullScreen
            <T>
            isLoading={isLoading}
            isError={isError}
            hasExportDataFromAllPage={hasExportDataFromAllPage}
            mapperRowCb={mapperRowCb}
            data={data}
            allData={allData}
            fullColumns={fullColumns}
            headColumns={headColumns}
            params={params}
            headSideBar={headSideBar}
            secondarySidebar={secondarySidebar}
            hasExport={hasExport}
            exportParams={exportParams}
            mapperColumnCb={mapperColumnCb}
            baseExportStyles={baseExportStyles}
            generateExportExcelRowStylesCb={generateExportExcelRowStylesCb}
            generateExportExcelHeadColumnStylesCb={generateExportExcelHeadColumnStylesCb}
            headerExportContents={headerExportContents}
            initialStickyHeader={initialStickyHeader}
            changeExportSidebarSettings={changeExportSidebarSettings}
            paginationProps={paginationProps}
            hasPdfExport={hasPdfExport}
            sx={sx}
            lastTableRow={lastTableRow}
            menuSettingsTable={menuSettingsTable}
            hasModalFullScreen={hasModalFullScreen}
            totalPage={totalPage}
        />
    )
}

export default TableFeatures;